import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.risk[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectRisk = (state) => state.risk?.risk;
export const selectRiskLoading = isLoadingSelector('riskStatus');

export const selectRiskHistory = (state) => state.risk?.riskHistory;
export const selectRiskHistoryLoading = isLoadingSelector('riskHistoryStatus');

export const selectRiskOrganizations = (state) => state.risk?.riskOrganizations;
export const selectRiskOrganizationsLoading = isLoadingSelector('riskOrganizationsStatus');

export const selectRiskConnectedPolicies = (state) => state.risk?.riskConnectedPolicies;
export const selectRiskConnectedPoliciesLoading = isLoadingSelector('riskConnectedPoliciesStatus');

export const selectCreateRiskLoading = isLoadingSelector('createRiskStatus');
export const selectUpdateRiskLoading = isLoadingSelector('updateRiskStatus');
export const selectDeleteRiskLoading = isLoadingSelector('deleteRiskStatus');
